import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@commenda/kakashi';
import { IWorkflowTemplate } from '@commenda/types';
import { CreateWorkflowTemplateVersionForm } from '../forms/CreateWorkflowTemplateVersionForm';

type TCreateWorkflowTemplateVersionModalProps = {
  isOpen: boolean;
  workflowTemplate: IWorkflowTemplate;
  onClose: () => void;
  onSuccess: () => void;
};

export const CreateWorkflowTemplateVersionModal = ({
  isOpen,
  workflowTemplate,
  onClose,
  onSuccess,
}: TCreateWorkflowTemplateVersionModalProps) => {
  return (
    <div>
      <Dialog open={isOpen} onOpenChange={onClose}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Create Workflow Template Version</DialogTitle>
          </DialogHeader>
          <CreateWorkflowTemplateVersionForm
            workflowTemplate={workflowTemplate}
            onSuccess={onSuccess}
            onCancel={onClose}
            formContentClassName="p-6"
            formFooterClassName="p-6"
          />
        </DialogContent>
      </Dialog>
    </div>
  );
};
